import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { resolveDualTimestamp } from './punchTimes';
import styles from './DualTimestamp.module.css';
export function DualTimestamp({ occurredAt, receivedAt }) {
    const view = resolveDualTimestamp({ occurredAt, receivedAt });
    if (!view.split) {
        return (_jsx("time", { className: styles.single, dateTime: occurredAt, children: view.occurred }));
    }
    return (_jsxs("span", { className: styles.dual, children: [_jsx("time", { className: styles.occurred, dateTime: occurredAt, children: view.occurred }), _jsxs("time", { className: styles.received, dateTime: receivedAt, children: ["\u00B7 received ", view.received] })] }));
}
//# sourceMappingURL=DualTimestamp.js.map